import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { environment } from 'src/environments/environment';
import { IndicadoresProjeto } from '../../models/indicadores-projeto.model';
import { IndicadoresPgService } from '../../services/indicadores-pg.service';
import { NavigationService } from '../../services/navigation.service';
import { ProjetoAgregadorService } from '../../services/projeto-agregador.service';

@Component({
  selector: 'app-detalhe-pg-indicadores-view',
  templateUrl: './detalhe-pg-indicadores-view.component.html',
  styleUrls: ['./detalhe-pg-indicadores-view.component.scss']
})
export class DetalhePgIndicadoresViewComponent extends BaseListComponent<IndicadoresProjeto> implements OnInit, OnDestroy {

  idProjeto: number;
  indicador: IndicadoresProjeto;
  type: string = '';
  projeto: any;
  modalPrintRef?: BsModalRef;
  infoImprimir?: any = {
    years: [],
    analise: true,
    ponto: true, 
    plano: true,
  };

  
  @ViewChild('modalPrint') modalPrint: TemplateRef<any>;

  constructor(
    private myService: IndicadoresPgService,
    private projetoService: ProjetoAgregadorService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private navigation: NavigationService,
    private modalService: BsModalService,
  ) {
    super()
  }

  ngOnInit(): void {
    this.indicador = this.activatedRoute.snapshot.data['entity'];
    this.type = this.activatedRoute.snapshot.data['type'];
    this.projetoService.getById( this.indicador['pg_id'] ).subscribe( ( res )=>{
      this.projeto = res;
      this.idProjeto = this.projeto.id;
    });
    this.loaded();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  bloqueioIndicadorProjeto(total: boolean = false) {
    this.loading()
    let obj = {};
    if (total) {
      obj = {
        full_blocked: this.indicador?.full_blocked ? "0" : "1",
      };
    } else {
      obj = {
        meta_blocked: this.indicador?.meta_blocked ? "0" : "1",
      };
    }
    this.addSub(
      this.myService.getBloqueio(this.indicador.id, obj).subscribe({
        next: (res) => {
          if (total) {
            this.indicador.full_blocked = !this.indicador.full_blocked;
          } else {
            this.indicador.meta_blocked = !this.indicador?.meta_blocked;
          }
          this.loaded();
          this.msgSuccess(res?.message);
        },
        error: (err) => {
          this.loaded();
          this.msgError(err.error?.message);
        },
      }),
    )
  }

  editar() {
    this.loading();
    this.router.navigate(['projetos', this.type ?? 'agregador', 'indicadores', this.indicador?.id, 'editar']);
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir() {
    this.loading();
    this.myService.delete(this.indicador.id).subscribe({
      next: (res) => {
        this.loaded();
        this.confirmation().subscribe(() => {
          this.voltar();
        });
      },
      error: (error) => {
        this.msgError(error.error?.message);
        this.loaded();
      }
    });
  }

  voltar() {
    if (this.type) {
      this.navigation.back(['projetos', this.type, this.indicador?.pg_id, 'indicadores']);
    } else {
      this.navigation.back(['projetos', 'agregador', this.indicador?.pg_id, 'detalhe', 'indicadores']);
    }
  }

  closePrintModal() {
    this.modalPrintRef?.hide();
  }

  openPrintModal() {
    this.modalPrintRef = this.modalService.show(this.modalPrint);
  }

  imprimir(){
    this.loading();
    const url = `${environment.serverUrl}/rest/relatorios/indicadores-agregador/${this.indicador?.id}?analises=${this.infoImprimir?.analise}&pontos=${this.infoImprimir?.ponto}&planos=${this.infoImprimir?.plano}&anos=${this.infoImprimir?.years?.length ? this.infoImprimir?.years : this.indicador?.years}`;
    window.open(url,'_blank');
    this.loaded();
  }
}
